import { createFileRoute } from '@tanstack/react-router';

import { TenderPage } from '@/features/subcontracts/tenders-page';
import { PERSONAL_BIDDER } from '@/lib/api/subcontracts';

export const Route = createFileRoute('/_app/me/services/tenders/$packageId')({
  component: PageRoute,
});

function PageRoute() {
  const { packageId } = Route.useParams();
  return <TenderPage orgId={PERSONAL_BIDDER} packageId={packageId} />;
}
